// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { fontConfig } from "@vanmeter/XDL/constants";
import { xBaseTheme } from "@vanmeter/XDL/types";
import { color, styledScrollbar } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            color: "common.background",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                && {
                    width: 33px;
                    height: 33px;
                    min-height: 33px;
                }
                & > ${IconWrapper} {
                    top: 0;
                    color: ${color("text.main")};
                }
                &:hover > ${IconWrapper}, &:focus > ${IconWrapper} {
                    color: ${color("common.white")};
                }
            `,
        },
        cssOverrides: {
            wrapper: css`
                display: flex;
                align-items: center;
            `,
            menu: css`
                overflow-y: auto;
                ${styledScrollbar()}
            `,
            /* to override safari (color:-apple-system-blue) browser native css on all buttons */
            menuItem: css`
                font-size: ${fontConfig.smallSingleLine.size}px;
                line-height: ${fontConfig.smallSingleLine.lineHeight};
                color: ${color("text.main")};
                &:hover {
                    background: ${color("common.ui15")};
                    color: ${color("common.ui1")};
                }
                &:active,
                &:focus {
                    background: ${color("common.ui16")};
                    color: ${color("common.ui1")};
                }
                &:disabled {
                    color: ${color("text.main", 0.3)};
                }
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
